import {
  buildMainFieldFilterParams,
  buildMainFieldParamsForRowSelection,
} from '../domain/dataKi/searchParams';
import {
  MAIN_FIELD_TYPE,
  MainFieldType,
  Option,
  QueryParameter,
} from '../domain/schemas';

/**
 * チェーン店一覧を表示するために必要なパラメータを作成
 *
 * チェーン店一覧を表示するために、検索時に詳細条件で指定した「機種,SISタイプ,メーカー」は支持率系項目の計算に必要な情報な為、パラメータとしてそれぞれ「kiListForSijiritu,sisTypesForSijiritu,makersForSijiritu」を付与する必要がある。
 * また、選択された行によって「kiList,sisTypes,makers」を付与する必要がある。
 * 仕様：https://www.notion.so/ForSijiritu-1c0a4e41249f81638081c138cb17cd4e?pvs=24
 */
export const dataKiKasidamaSearchConditionParams = <
  T extends {
    mainField?: MainFieldType;
    kiList?: string[];
    sisTypes?: string[];
    makers?: string[];
    makerGroups?: string[];
    kiListForSijiritu?: string[];
    sisTypesForSijiritu?: string[];
    makersForSijiritu?: string[];
  }
>(
  mainField: QueryParameter,
  dataKi1stRow: QueryParameter | undefined,
  searchCondition: T,
  makerOptions?: Option[] | undefined
) => {
  // 詳細条件で設定された機種やSISタイプ、メーカーの支持率計算のために必要なパラメータ
  const searchConditionForTypes = {
    makers: searchCondition.makers,
    makerGroups: searchCondition.makerGroups,
    sisTypes: searchCondition.sisTypes,
    kiListForSijiritu: searchCondition.kiListForSijiritu,
    sisTypesForSijiritu: searchCondition.sisTypesForSijiritu,
    makersForSijiritu: searchCondition.makersForSijiritu,
  };

  const selectedRowMainFieldType = buildMainFieldParamsForRowSelection(
    mainField,
    searchCondition,
    makerOptions
  );

  // 機種行を選択したときの選択されたタイプ(makers[])やメーカー(sisTypes[])を把握
  // 出力がタイプ・メーカーの場合に、どのタイプやメーカーから選択された機種行なのかを判別するため
  if (dataKi1stRow) {
    // 1階層目がメーカーグループのとき、3行目は kiList だけが selectedRowMainFieldType に載り、
    // makers は searchConditionForTypes のまま（詳細条件の全メーカー）になる。グループ内に絞る。
    const narrowedByFirstRowMakerOrGroup =
      dataKi1stRow.name === 'makerGroups'
        ? buildMainFieldFilterParams(
            {
              name: 'makerGroups',
              value: dataKi1stRow.value,
            },
            searchCondition,
            makerOptions
          )
        : dataKi1stRow.name === 'makers'
        ? buildMainFieldFilterParams(
            {
              name: 'makers',
              value: dataKi1stRow.value,
            },
            searchCondition,
            makerOptions
          )
        : undefined;

    return {
      ...searchConditionForTypes,
      ...selectedRowMainFieldType,
      ...(narrowedByFirstRowMakerOrGroup ?? {}),
      [dataKi1stRow.name]: [dataKi1stRow.value],
    };
  }

  // 出力がタイプ・メーカーで、機種行ではない箇所で選択された場合
  if (searchCondition.mainField !== MAIN_FIELD_TYPE.KI_TUSHO_MEI) {
    return {
      ...searchConditionForTypes,
      ...selectedRowMainFieldType,
      kiList: searchCondition.kiList,
    };
  }

  return {
    ...searchConditionForTypes,
    ...selectedRowMainFieldType,
    kiList: [mainField.value],
  };
};
